import { render, staticRenderFns } from "./commonPicker.vue?vue&type=template&id=31d1842e&scoped=true"
import script from "./commonPicker.vue?vue&type=script&lang=js"
export * from "./commonPicker.vue?vue&type=script&lang=js"
import style0 from "./commonPicker.vue?vue&type=style&index=0&id=31d1842e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d1842e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/hybrid-app/ph-refusaldrainage-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d1842e')) {
      api.createRecord('31d1842e', component.options)
    } else {
      api.reload('31d1842e', component.options)
    }
    module.hot.accept("./commonPicker.vue?vue&type=template&id=31d1842e&scoped=true", function () {
      api.rerender('31d1842e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPicker.vue"
export default component.exports